import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { CreditDataResultModel, customCreateAccount, CustomeCreateAccountParameter } from "@tSurya/Services/CustomCreateAccountService";
import {
    freightcalculator,
    FreightcalculatorApiParameter,
    FreightcalculatorResultModel,
} from "@tSurya/Services/FreightService";

type HandlerType = ApiHandler<
CustomeCreateAccountParameter & HasOnSuccess<CreditDataResultModel>,
CreditDataResultModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await customCreateAccount(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const createAddAccount = createHandlerChainRunner(chain, "CreateAddAccount");
export default createAddAccount;
